var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03161 1.31292L1.10219 1.21478C1.36101 0.90413 1.76601 0.875896 2.0514 1.13005L2.13316 1.21478L8.42172 8.76233L14.7103 1.21478C14.995 0.873073 15.4565 0.873073 15.7412 1.21478C16.0259 1.55648 16.0259 2.11051 15.7412 2.45222L9.45302 10.0002L15.7412 17.5481C16.0001 17.8587 16.0236 18.3449 15.8118 18.6874L15.7412 18.7855C15.4825 19.0962 15.0774 19.1244 14.7921 18.8702L14.7103 18.7855L8.42172 11.238L2.13316 18.7855C1.84847 19.1272 1.38688 19.1272 1.10219 18.7855C0.817502 18.4438 0.817502 17.8899 1.10219 17.5481L7.39042 10.0002L1.10219 2.45222C0.843377 2.14157 0.819854 1.65546 1.03161 1.31292Z",
    fill: "#545565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ddf9e581510f85ddd1006530c7f5150e.svg";
export { ForwardRef as ReactComponent };